import { render, staticRenderFns } from "./ShortenedText.vue?vue&type=template&id=21c67dc6"
import script from "./ShortenedText.vue?vue&type=script&lang=ts"
export * from "./ShortenedText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c67dc6')) {
      api.createRecord('21c67dc6', component.options)
    } else {
      api.reload('21c67dc6', component.options)
    }
    module.hot.accept("./ShortenedText.vue?vue&type=template&id=21c67dc6", function () {
      api.rerender('21c67dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ShortenedText.vue"
export default component.exports